import { render, staticRenderFns } from "./ReTextarea.vue?vue&type=template&id=6a4fe66f&"
import script from "./ReTextarea.vue?vue&type=script&lang=js&"
export * from "./ReTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports